import { useEffect, useRef } from 'react';

const focusElement = (element, focusOptions) => {
  if (!element || typeof element.focus !== 'function') return;
  if (typeof document !== 'undefined' && document.body?.contains) {
    try {
      if (!document.body.contains(element)) return;
    } catch {
      // ignore dom exceptions
    }
  }
  element.focus(focusOptions ?? { preventScroll: true });
};

export const useFocusRestore = ({ isOpen, focusRef, returnFocusRef, focusOptions }) => {
  const fallbackRef = useRef(null);

  useEffect(() => {
    if (typeof document === 'undefined' || !isOpen) return undefined;

    fallbackRef.current = document.activeElement;

    focusElement(focusRef?.current, focusOptions);

    return () => {
      const target = returnFocusRef?.current || fallbackRef.current;
      focusElement(target, focusOptions);
    };
  }, [isOpen, focusRef, returnFocusRef, focusOptions]);
};

export default useFocusRestore;
